import { render, staticRenderFns } from "./AddingProductProfilePopup.vue?vue&type=template&id=4d6e0694"
import script from "./AddingProductProfilePopup.vue?vue&type=script&lang=js"
export * from "./AddingProductProfilePopup.vue?vue&type=script&lang=js"
import style0 from "./AddingProductProfilePopup.vue?vue&type=style&index=0&id=4d6e0694&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports